module.exports = __webpack_public_path__ + "static/media/subjects-bg.0ef90576.svg";